import { LocalAssetOptions } from '../types'

const getDataFromLocalstorage = (key: string) => {
  const jsonData = localStorage.getItem(key)
  if (!jsonData) {
    return null
  }

  return JSON.parse(jsonData) || null
}

const getActiveProjectCanonicalName = (): string => {
  const projectIdentityObject = getDataFromLocalstorage('projectIdentity')
  return projectIdentityObject?.projectName || ''
}

const getAssetPort = (): string => {
  const projectIdentityObject = getDataFromLocalstorage('projectIdentity')
  return projectIdentityObject?.assetPort || ''
}

const getAssetHost = (): string => {
  const projectIdentityObject = getDataFromLocalstorage('projectIdentity')
  return projectIdentityObject?.assetHost || ''
}

const getAssetOptions = (): LocalAssetOptions => {
  const projectIdentityObject = getDataFromLocalstorage('projectIdentity')
  return (
    projectIdentityObject?.assetOptions || {
      localImages: false,
      localVideos: false,
    }
  )
}

export {
  getActiveProjectCanonicalName,
  getAssetPort,
  getAssetHost,
  getAssetOptions,
}
